<template>
    <div>
        <div id="figures" v-if="location == 1">
            <img src="/assets/img/figures-g-green-hor.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-hor.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-hor.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-hor.svg" class="figure boy-girl" />
        </div>

        <div id="figures" v-if="location == 2">
            <img src="/assets/img/figures-g-green-kus.svg" class="figure girl-green" />
            <img src="/assets/img/figures-g-yellow-kus.svg" class="figure girl-yellow" />
            <img src="/assets/img/figures-g-b-kus.svg" class="figure girl-boy" />
            <img src="/assets/img/figures-b-g-kus.svg" class="figure boy-girl" />
        </div>


        <section class="offer page-wrapper-inner" v-if="dataIsInit">
            <div class="block">

                <div>
                    <label class="subtitle horgen" v-if="location == 1">Horgen</label>
                    <label class="subtitle kuesnacht"  v-if="location == 2">Küsnacht</label>
                    <h2>{{ trans.global.primary[lang] }}</h2>

                    <p>{{ trans.primary.intro[lang] }}</p>

                    <!-- <ul class="link-block">
                        <li><a href="#" class="more">{{ trans.global.organisation[lang] }} +</a></li>
                        <li><a href="#" class="more">{{ trans.global.terms[lang] }} +</a></li>
                    </ul> -->
                </div>

                <div><ul class="block-list"> <li><label>{{ trans['home']['grad1to6'][lang] }}</label><span>{{ trans['global']['chf_month'][lang] }}</span><em>2310.&mdash;</em></li></ul></div>

                <div>
                    <h5><img src="/assets/img/icon-lunch.svg" />  Hot Lunch (optional)</h5>
                    <ul class="block-list">
                        <li style="padding-top:0;">
                            <lunch-component :trans="trans" :lang="lang" :onlyDiDo="true" :noindividual="location == 2 ? true : false" :labelAllDaysWithoutWe="true" ref="lunch" class="noflex" :options="[

                                {id:'mo',label: trans.global.monday[lang]},
                                {id:'di',label: trans.global.tuesday[lang]},
                                {id:'do',label: trans.global.thursday[lang]},
                                {id:'fr',label: trans.global.friday[lang]}

                            ]" :status-open="true" :service="lunchService" :selections="selections" :location="location" :session="session"
                            @submited="importLunchdata"
                            ></lunch-component>
                        </li>
                    </ul>

                    <div class="summarybox">
                        <label>{{ trans.global.chf_month_total[lang] }}:</label>
                        <em>{{ priceSummary | francs}}</em>
                    </div>
                    <div class="applicationbox" >
                        <p>{{ trans.global.c2a_finish[lang] }}</p>
                        <button class="btnoutline" v-on:click="storeData(modulRelevantSelections,4,'pdf')">{{ trans.global.downloadpdf[lang] }}</button>
                        <button class="btn" v-if="appmode=='offer'"  v-on:click="storeData(modulRelevantSelections,4,'app')">{{ trans.global.register[lang] }}</button>
                        <button class="btn" v-if="appmode=='change'" v-on:click="storeData(modulRelevantSelections,4,'app')">{{ trans.global.confirm[lang] }}</button>


                        <!-- <br><br>
                        <a v-if="appmode == 'offer' && location == 1" href="/daycare/horgen/1/offer" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 1" href="/daycare/horgen/1/change" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'offer' && location == 2" href="/daycare/kuesnacht/2/offer" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a>
                        <a v-if="appmode == 'change' && location == 2" href="/daycare/kuesnacht/2/change" class="btn btnoutline" >{{ trans.global.daycare_btn[lang] }}</a> -->


                    </div>
                </div>


                <div v-if="dataIsInit" >



                </div>


            </div>
        </section>

         <div class="teaser-wrapper">
            <h3 class="title"></h3>
            <div class="grid">
                 <div class="teaser">
                    <p>{{ trans.teaser.about_pri.text[lang] }}</p>
                    <a :href="trans.teaser.about_pri.link[location][lang]" target="_blank">{{ trans.teaser.about_pri.linktext[lang] }}</a>
                </div>
                <div class="teaser" v-if="location != 2">
                    <p>{{ trans.teaser.video_pri.text[lang] }}</p>
                    <a :href="trans.teaser.video_pri.link[location][lang]" target="_blank">{{ trans.teaser.video_pri.linktext[lang] }}</a>
                </div>
            </div>
        </div>

    </div>
</template>




<script>

    import * as helpers from "./helpers.js";
    import * as methods from "./methods.js";

    export default {


        data: function() {
            return  {

                days: [
                    { id: 'mo', name: 'Montag', disabled: true },
                    { id: 'di', name: 'Dienstag', disabled: false },
                    { id: 'mi', name: 'Mittwoch', disabled: true },
                    { id: 'do', name: 'Donnerstag', disabled: false },
                    { id: 'fr', name: 'Freitag', disabled: true }
                ],
                config:{
                    sectorIds: [ 4 , 5 ], // Kindergarten, Sonstiges
                    serviceIdPrimarschule: 16,
                    serviceIdLunchs: 17,
                },
                choosenSelectionIds: [],
                mainservice: null,
                services: [],
                errors: [],
                selections: [],
                selectionsOrigin: [],
                dataIsInit: false,

            }
        },
        props: {
            session: {
                type: String,
                required: true
            },
            location: {
                type: Number,
                required: true
            },
            lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },
            appmode: {
                type: String,
                required: true
            },
        },
        computed: {
            lunchService: function () {
                let id = this.config.serviceIdLunchs;
                var service = this.services.filter(function(item) {
                    return item.id == id;
                });
                return service[0];
            },
            lunchSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return item.service_id == app.config.serviceIdLunchs;
                });
            },
            modulRelevantSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    let found = app.services.find(element => element.id == item.service_id);
                    return found !== undefined
                });
            },
            choosenSelections: function () {
                let app = this;
                return this.selections.filter(function(item) {
                    return app.choosenSelectionIds.indexOf(item.id) !== -1;
                });
            },
            price: function () {
                let app = this;
                return app.choosenSelections[0].service.relevantPrice.price;
            },
            lunchPriceTotal: function () {
                var price = 0;
                for(var i = 0; i < this.lunchSelections.length; i++)
                {
                    price = price + this.lunchSelections[i].service.relevantPrice.price_brutto
                }
                return price
            },
            priceSummary: function () {
                return this.price + this.lunchPriceTotal
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {

                let app = this;



                // this.selections = [];
                // this.selectionsOrigin = [];



                // load for each sector the services
                axios.get('/api/services/bysectors/' + this.config.sectorIds.join() + '/' + this.location)
                .then(response => {
                    this.services = this.services.concat(response.data);

                    app.dataInit();
                    // vorübergehend deaktiviert
                    // axios.get('/api/session/data/' + this.session )
                    //     .then(response => {
                    //         this.selections = response.data.selections.filter(function(item) {
                    //             return item.location_id == app.location;
                    //         });
                    //         this.selectionsOrigin = this.selections;
                    //         app.dataInit();
                    //     })
                    //     .catch(e => {
                    //         this.errors.push(e)
                    //     });

                })
                .catch(e => {
                    this.errors.push(e)
                });
            },

            dataInit() {
                let app = this;
                let selection = this.getSingleSelection( [ this.config.serviceIdPrimarschule ] );

                if(selection.length == 0){
                    selection[0] = this.createNewSelection( this.config.serviceIdPrimarschule );
                }
                app.choosenSelectionIds.push( selection[0].id );
                app.dataIsInit = true;

            },


            checkCondition(ref)
            {
                   let app = this;

                // select the service (price relevant) for the current settings
                app.mainservice = app.config.serviceIdPrimarschule;

                serv = app.services.filter(function(item) { return item.id == app.config.serviceIdPrimarschule});


                app.choosenSelections[0].service = serv[0];
                app.choosenSelections[0].service_id = serv[0].id;
            },

            ...helpers,
            ...methods,




        }

    }
</script>
